<template>
  <div class="sold-disposed-items-container sold-disposed-items-page--glass glass-tab-page">
    <BrucdcumHeader
      :breadcrumb="['Fixed Assets', 'Sold Disposed Items']"
      :show-back-button="true"
      :back-fallback="backFallbackRoute"
    />

    <div class="glass-tab-view glass-tab-view--flush sold-disposed-items-glass-shell">
      <div class="glass-tab-view__content sold-disposed-items-page-stack">
        <div class="sold-disposed-items-header-block">
          <div class="sold-disposed-items-header-row">
            <div class="sold-disposed-items-header-row__text">
              <h2 class="sold-disposed-items-title">Sold & Disposed Items</h2>
              <p class="sold-disposed-items-subtitle">
                Review fixed assets that have been sold or disposed
              </p>
            </div>
            <div class="sold-disposed-items-header-actions">
              <SecondaryButton
                label="Export to CSV"
                icon="bi bi-download"
                @click="handleExportCsv"
              />
              <PrimaryButton
                label="Add a New Asset"
                icon="bi bi-plus-lg"
                @click="openNewAssetModal"
              />
            </div>
          </div>
        </div>

        <div class="sold-disposed-items-table-panel glass-tab-panel--nested">
          <h3 class="sold-disposed-items-table-heading">Sold & disposed items</h3>
          <div class="sold-disposed-items-table-section consultant-glass-table-section">
            <div class="consultant-glass-table-responsive consultant-glass-table-responsive--framed">
              <div class="consultant-glass-table-scroll-x">
                <table class="consultant-glass-table sold-disposed-items-table">
                  <thead>
                    <tr>
                      <th>Item</th>
                      <th>Asset Number</th>
                      <th>Account</th>
                      <th>Disposal Date</th>
                      <th>Disposal Price</th>
                      <th>Gains/Losses</th>
                      <th>Show history</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="soldDisposedItems.length === 0">
                      <td colspan="7" class="consultant-glass-table-no-records sold-disposed-items-no-records">
                        No records to show
                      </td>
                    </tr>
                    <template v-else>
                      <tr
                        v-for="(item, idx) in soldDisposedItems"
                        :key="item.assetNumber + idx"
                        class="consultant-glass-table-row sold-disposed-items-table-row"
                        :style="{ '--sdi-row-delay': `${0.04 + Math.min(idx, 14) * 0.025}s` }"
                      >
                        <td>{{ item.item }}</td>
                        <td>{{ item.assetNumber }}</td>
                        <td>{{ item.account }}</td>
                        <td>{{ item.disposalDate }}</td>
                        <td class="sold-disposed-items-amount-cell">{{ item.disposalPrice }}</td>
                        <td
                          class="sold-disposed-items-amount-cell"
                          :class="gainLossClass(item.gainsLosses)"
                        >
                          {{ item.gainsLosses }}
                        </td>
                        <td class="sold-disposed-items-history-cell">{{ item.showHistory }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Transition name="sold-disposed-items-modal-overlay">
      <div
        v-if="showNewAssetModal"
        class="sold-disposed-items-modal-overlay sold-disposed-items-modal-overlay--glass"
        @click.self="closeNewAssetModal"
      >
        <Transition name="sold-disposed-items-modal-panel" appear>
          <div
            v-if="showNewAssetModal"
            class="sold-disposed-items-modal-card sold-disposed-items-modal-card--glass"
            role="dialog"
            aria-modal="true"
            aria-labelledby="sold-disposed-items-new-asset-title"
            @click.stop
          >
            <div class="sold-disposed-items-modal-header sold-disposed-items-modal-header--glass">
              <h2 id="sold-disposed-items-new-asset-title" class="sold-disposed-items-modal-title">
                New Fixed Asset
              </h2>
              <button
                type="button"
                class="sold-disposed-items-modal-close-btn"
                aria-label="Close"
                title="Close"
                @click="closeNewAssetModal"
              >
                <i class="bi bi-x-lg" aria-hidden="true"></i>
              </button>
            </div>
            <div class="sold-disposed-items-modal-body sold-disposed-items-modal-body--glass">
              <NewFixedAsset embedded @cancel="closeNewAssetModal" @saved="closeNewAssetModal" />
            </div>
          </div>
        </Transition>
      </div>
    </Transition>
  </div>
</template>

<script>
import '../styles/SoldDisposedItems.css';
import '../styles/sold-disposed-items-glass.css';
import BrucdcumHeader from '@/components/BrucdcumHeader.vue';
import PrimaryButton from '@/modules/consultant/components/PrimaryButton.vue';
import SecondaryButton from '@/modules/consultant/components/SecondaryButton.vue';
import NewFixedAsset from './NewFixedAsset.vue';

export default {
  name: 'SoldDisposedItems',
  components: {
    BrucdcumHeader,
    PrimaryButton,
    SecondaryButton,
    NewFixedAsset,
  },
  data() {
    return {
      showNewAssetModal: false,
      soldDisposedItems: [],
    };
  },
  computed: {
    companyId() {
      return this.$route.params.id || this.$route.params.companyId;
    },
    backFallbackRoute() {
      const companyId = this.companyId || this.$route.params.id;
      return `/company/${companyId}/dashboard/company/fixed-assets/registered-items`;
    },
  },
  methods: {
    gainLossClass(value) {
      if (!value || typeof value !== 'string') return '';
      if (value.includes('-') || value.startsWith('(')) {
        return 'sold-disposed-items-gain-cell--negative';
      }
      if (value !== '$0.00' && value !== '$ 0.00') {
        return 'sold-disposed-items-gain-cell--positive';
      }
      return '';
    },
    openNewAssetModal() {
      this.showNewAssetModal = true;
    },
    closeNewAssetModal() {
      this.showNewAssetModal = false;
    },
    handleExportCsv() {
      this.$toast?.info('Export to CSV coming soon!') || alert('Export to CSV coming soon!');
    },
  },
};
</script>
